import { observer } from "mobx-react-lite";

import { Combobox } from "../../fields/combobox";
import { type EnumValues, valuesToMap } from "../../fields/utils";

export const CellCombobox = observer(function CellCombobox<
  T extends object,
  V extends string | number,
>({
  model,
  attr,
  values,
  listTitle,
  onChange,
  disabled,
  required,
}: {
  model: T;
  attr: keyof T;
  values: EnumValues<V>;
  listTitle?: string;
  onChange?: (newValue: V) => void;
  disabled?: boolean;
  required?: boolean;
}) {
  const options = [...valuesToMap(values).entries()].map(([value, label]) => ({
    value,
    label,
  }));

  if (disabled) {
    return <>{String(model[attr] ?? "")}</>;
  }

  return (
    <Combobox
      attr={attr}
      model={model}
      options={options}
      placeholder={listTitle}
      onChange={onChange}
      required={required}
    />
  );
});
